export var emitNames;
(function (emitNames) {
    emitNames["onScroll"] = "scroll";
    emitNames["onScrollLower"] = "scroll-lower";
    emitNames["onScrollUpper"] = "scroll-upper";
})(emitNames || (emitNames = {}));
